var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('side-menu')],1),_c('div',{staticClass:"col-8"},[_c('contents-display')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }